import CONFIG from "./../config.json";
import {cacheGetCacheTime} from "./cache.js";
import {mapsPrefetchVegueries} from "./maps.js";
import {postersEscapeSpacesAndApostrophes} from "./posters.js";
import {Log} from "./log.js";
import {i18nGetPageLanguage, i18nText} from "./i18n.js";
import {labelsFetchCatalog, labelsGetDisplayLabel} from "./labels.js";


let tagsTopLabels = ["Festa", "Fira", "Esport", "Música", "Cinema", "Teatre", "Per nens"];

function tagsDynamicFetch()
{
    return new Promise(function (resolve, reject)
    {
        let resource = `${CONFIG.posters_api_url}/resource/poster/public/tagsnumber`;

        const cacheTime = cacheGetCacheTime();
        if ((cacheTime !== null) && (cacheTime !== ""))
        {
            resource += "?cacheTime=" + cacheTime;
        }

        const prefetchVegueries = mapsPrefetchVegueries();
        const labelsCatalog = labelsFetchCatalog();

        fetch(resource)
                .then(response => response.json())
                .then(aux =>
                {
                    Promise.allSettled([prefetchVegueries, labelsCatalog]).finally(() =>
                    {
                        tagsDynamicMapLegendCreateAndAppend(aux);
                        resolve(true);
                    });
                })
                .catch(err =>
                {
                    Log.print("Tag dynamic fetch error: " + err);
                    reject(err);
                });
    });
}

function tagsCollectByRegion(tagsJson)
{
    const byRegion = tagsJson && tagsJson.byRegion ? tagsJson.byRegion : {};
    const labelTotals = new Map();
    const labelBestRegion = new Map();
    const townBestRegion = new Map();
    const townBestCount = new Map();
    const townEntries = [];

    Object.keys(byRegion).forEach((region) =>
    {
        const regionData = byRegion[region] || {};
        const labels = regionData.labels || {};
        const towns = regionData.towns || {};

        Object.entries(labels).forEach(([label, count]) =>
        {
            const total = labelTotals.get(label) || 0;
            labelTotals.set(label, total + count);
            const best = labelBestRegion.get(label);
            if (!best || count > best.count)
            {
                labelBestRegion.set(label, {region, count});
            }
        });

        Object.entries(towns).forEach(([town, count]) =>
        {
            townEntries.push([town, count, region]);
            const bestCount = townBestCount.get(town) || 0;
            if (count > bestCount)
            {
                townBestCount.set(town, count);
                townBestRegion.set(town, region);
            }
        });
    });

    return {
        labelTotals,
        labelBestRegion,
        townBestRegion,
        townEntries
    };
}

function tagsGetLabelEntries(tagsJson, minimumCount = 0)
{
    const baseLabels = tagsJson && tagsJson.labels ? tagsJson.labels : {};
    const hasBase = Object.keys(baseLabels).length >= minimumCount;
    const collected = tagsCollectByRegion(tagsJson);
    const labelEntries = [];

    if (hasBase)
    {
        Object.entries(baseLabels).forEach(([label, count]) =>
        {
            labelEntries.push([label, count, null]);
        });
        return labelEntries;
    }

    collected.labelTotals.forEach((count, label) =>
    {
        const best = collected.labelBestRegion.get(label);
        const region = best ? best.region : null;
        labelEntries.push([label, count, region]);
    });

    return labelEntries;
}

function tagsGetTownEntries(tagsJson)
{
    const baseTowns = tagsJson && tagsJson.towns ? tagsJson.towns : {};
    const hasBase = Object.keys(baseTowns).length > 0;
    const collected = tagsCollectByRegion(tagsJson);
    const townEntries = [];

    if (hasBase)
    {
        Object.entries(baseTowns).forEach(([town, count]) =>
        {
            const region = collected.townBestRegion.get(town) || null;
            townEntries.push([town, count, region]);
        });
        return townEntries;
    }

    return collected.townEntries;
}

function tagsDynamicMapLegendCreateAndAppend(tagsJson)
{
    const dynamicLegen = document.getElementById('mapLegendLabels');
    const language = i18nGetPageLanguage();
    if (dynamicLegen !== null)
    {
        const tags = tagsGetLabelEntries(tagsJson, 7).map(([label, count, region]) => [label, count, region]);

        if (tags.length >= 7)
        {
            tagsTopLabels = tags.sort((a, b) => b[1] - a[1])
                    .slice(0, 7)
                    .map(entry => entry[0]);

            const htmlTags = tagsTopLabels.map((label, index) =>
            {
                const scapedLabel = postersEscapeSpacesAndApostrophes(label);
                const labelClass = `map${index + 1}`;
                const displayLabel = labelsGetDisplayLabel(label, language);
                return `
                    <span class="mapLabels">
                        <input 
                            name="labelFilter" 
                            type="radio" 
                            onchange="mapRadioLabelFilterChange(event)" 
                            value="${label}"
                    >
                    ${displayLabel}
                    <span class="${labelClass}"></span>
                    </span>
                    `;
            });

            htmlTags[7] = `<span class="mapLabels">
                            <input 
                                name="labelFilter" 
                                type="radio" 
                                onchange="mapRadioLabelFilterChange(event)" 
                                value="" 
                                checked="checked">
                                ${i18nText(language).all}
                                <span class="mapAltres"></span>
                            </span>
                          `;


            dynamicLegen.innerHTML = htmlTags.join("\n");
        }
    }
}

export {tagsDynamicFetch, tagsTopLabels};



